export class MessageTypeToTemplateMapping {
  custId: string = null;
  messageTypeId: number = null;
  templateId: string = null;

  constructor(obj?: MessageTypeToTemplateMapping) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
